import { render } from "./MTag.vue?vue&type=template&id=4f712e1d"
import script from "./MTag.vue?vue&type=script&lang=js"
export * from "./MTag.vue?vue&type=script&lang=js"

import "./MTag.vue?vue&type=style&index=0&id=4f712e1d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__